import React from 'react';
import ourTeamImage from '../../../assets/images/home_screen/our_team.webp';
import GradientOutlineButton from '../../../components/atoms/GradientOutlineButton';

const OurTeam = () => {
  return (
    <main
      id="our_team"
      className="flex flex-col md:flex-row justify-center items-end max-w-[1200px] mx-auto h-full px-4 md:px-10 py-8 md:py-20 z-10 gap-10 md:gap-20"
    >
      <div className="flex flex-col gap-2 flex-1">
        <h2 className="text-[52px] text-primary font-bold">Our Team</h2>
        <h4 className="text-2xl text-primary font-semibold">
          Guidepost Pediatric Therapies <br /> and Educational Services
        </h4>
        <p className="text-secondary text-lg">
          At Guidepost Pediatrics we are passionate about helping every child
          reach their full potential using state of art modalities in pediatric
          occupational, physical and speech therapy. The Guidepost team,
          composed of dedicated highly qualified professionals, specialize in
          pediatric therapies and educational support. We offer a range of
          services designed to address your child’s needs bringing lasting
          changes and results to quality of life. We offer a warm and welcoming
          environment with therapeutic equipment and sensory gym where
          neurodivergent children feel right at home.
        </p>

        <div className="mt-4">
          <GradientOutlineButton
            text={'Meet Our Staff'}
            navigateTo="/our-team"
            isDark={false}
          />
        </div>
      </div>
      <div className="flex-1">
        <img
          src={ourTeamImage}
          alt="Children participating in educational crafts at Guidepost Pediatrics"
          className="w-auto h-[400px]"
        />
        <div className="flex flex-col items-center max-w-[450px] mt-6">
          <p className="text-pink text-xl italic font-semibold ">
            "“The owner is absolutely amazing and a very professional woman. I
            highly recommend Guidepost!”
            <span className="relative top-5 left-24">- J.C.</span>
          </p>
        </div>
      </div>
    </main>
  );
};

export default OurTeam;
